import React from 'react';

import Image from 'next/image';

import {
  Box,
  LinearProgress
} from "@mui/material";

export default function Loading () {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="primary.main"
    >
      <Box>
        <Image src="/logos/mb-logo.svg" width={205} height={25} alt="MechanicBuddy" />
      </Box>
      <Box width="80%" mt={2}>
        <LinearProgress color="secondary" />
      </Box>
    </Box>
  )
}